import { render, staticRenderFns } from "./IconHeadset.vue?vue&type=template&id=08a4c668&scoped=true&"
import script from "./IconHeadset.vue?vue&type=script&lang=js&"
export * from "./IconHeadset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a4c668",
  null
  
)

export default component.exports